import { Col, Form, Input, Modal, Row, Select } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";

import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import SingleImageUpload from "../../components/SingleImageUpload";
const { Option } = Select;

const AddForm = ({ api, show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);

  const allowedImageTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
  ];

  useEffect(() => {
    if (!data) return;
    setImage(data?.image);
    form.setFieldsValue({
      name: data?.name,
      type: data?.type,
      image: data?.image,
    });
  }, [data]);

  const handleImage = (files) => {
    if (files.length > 0) {
      setImage(files[0].url);
      form.setFieldsValue({ image: files[0]?.url || null });
    } else {
      setImage(null);
      form.setFieldsValue({ image: null });
    }
  };

  const onCreate = (values) => {
    const { name, type } = values;
    setLoading(true);
    const payload = {};
    payload.name = name;
    payload.image = image;
    payload.type = type;
    setLoading(true);
    request({
      url: `${data ? api.addEdit + "/" + data._id : api.addEdit}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        console.log("Response data:", data);
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      width={700}
      okText={data ? "Update" : "Add"}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{
          dob: moment("1990-01-01", "YYYY-MM-DD"),
        }}
      >
        <div className="add_user_title">
          <h4 className="modal_title_cls">{`${
            (data ? "Edit " : "Add ") + "Sport Category"
          }`}</h4>
        </div>
        <Row gutter={[16, 0]}>
          <Col span={24} sm={24}>
            <Form.Item
              label={`Category Name`}
              name="name"
              normalize={(value) => value?.trimStart().slice(0, 50)}
              rules={[
                { required: true, message: "Please enter the Category name" },
                {
                  max: 50,
                  message: "Category name must be 50 characters or fewer",
                },
              ]}
            >
              <Input
                autoComplete="off"
                maxLength={50}
                placeholder="Enter The Category Name"
              />
            </Form.Item>
          </Col>

          <Col span={24} md={24}>
            <Form.Item
              label="Category Image"
              name="image"
              // rules={[
              //   { required: true, message: "Please select Category Image" },
              // ]}
              getValueFromEvent={(e) => e?.[0]?.url}
            >
              <SingleImageUpload
                value={image ? [{ url: image }] : []}
                fileType={allowedImageTypes}
                imageType="content"
                btnName={"Image"}
                placeholder="Please upload an image"
                onChange={handleImage}
              />
              <div
                style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}
              >
                ⚠️ Note: Image should be less than 5MB, in JPG/PNG format only.
              </div>
            </Form.Item>

            {image && (
              <>
                <div
                  onClick={() => setPreviewVisible(true)}
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #eee",
                    cursor: "pointer",
                    marginTop: 12,
                  }}
                >
                  <img
                    src={image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <Modal
                  open={previewVisible}
                  footer={null}
                  onCancel={() => setPreviewVisible(false)}
                  centered
                  width={600}
                  zIndex={3000}
                  getContainer={false}
                >
                  <img
                    alt="Preview"
                    style={{ width: "150%", borderRadius: "1px" }}
                    src={image}
                  />
                </Modal>
              </>
            )}
          </Col>
          <Col span={24} sm={24}>
            <Form.Item
              label="Category Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please select the Category Type",
                },
              ]}
            >
              <Select placeholder="Select Category Type">
                <Option value="Elementary">Elementary</Option>
                <Option value="Advanced">Advanced</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
